//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('edgeRelations', {
//        templateUrl: 'views/components/views/edgeRelations/edgeRelations.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'ttGridFactory', function (stateService, ttGridFactory)  {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                gridReady: true
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_edgerelationsComponentGrid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            })
//                .setToolbar({ wrapping: true })
//                .setLoadDataFunction({
//                    method: 3209,
//                    parameters: {}
//                })
//                .setCustomToolbarButtons([{
//                    name: 'new',
//                    text: 'new',
//                    func: () => stateService.go('edgerelation', { edgerelation_keyno: '0' }),
//                    icon: 'fa-plus',
//                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
//                    translate: true
//                }]);

//            // #endregion VARIABLES & DEFINITIONS

//        }]
//    });
//})();
